import { render, staticRenderFns } from "./authorVideo.vue?vue&type=template&id=1b2f605a&scoped=true"
import script from "./authorVideo.vue?vue&type=script&lang=js"
export * from "./authorVideo.vue?vue&type=script&lang=js"
import style0 from "./authorVideo.vue?vue&type=style&index=0&id=1b2f605a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f605a",
  null
  
)

export default component.exports